/* ARRAY - collection page. Bound by delegation on document: an inline script
   inside a Horizon section renders but never binds.

   Two small jobs only. The sort control submits itself on change, and a shade
   swatch re-points its card - hovering previews that shade's photo, clicking
   commits it and makes the card's links go straight to that variant, so a
   shopper who picks a shade in the grid lands on the product already set to
   it. Leaving the card restores the committed shade, not the original, which
   is why `__pick` is kept separately from `__base`.

   29 Sep 2026 FIX - "the photo only changes after I move the cursor away":
   the swatch WAS swapping the main photo at once, but the card's hover photo
   (.bc-img--alt, cross-fades in on :hover) sat on top of it the whole time the
   cursor was inside the card. Now the CSS drops the hover photo while the
   swatch row is hovered and for good once a shade is picked (class is-picked,
   set below). The shade photos are also preloaded the first time the cursor
   enters a card, so the swap does not wait on the network. */
(function () {
  if (window.__bdColBound) return;
  window.__bdColBound = true;

  /* the hover-photo override lives here, next to the behaviour it serves, so
     assets/beyondads-collection.css did not have to be re-sent for one rule */
  var st = document.createElement('style');
  st.textContent =
    '.beyondads-collection .bc-card:has(.bc-swatches:hover) .bc-img--alt,' +
    '.beyondads-collection .bc-card.is-picked .bc-img--alt{opacity:0!important;transition-duration:.12s}';
  document.head.appendChild(st);

  function card(el) { return el.closest ? el.closest('[data-bc-card]') : null; }

  function setImg(c, src) {
    var img = c.querySelector('[data-bc-img]');
    if (!img || !src || img.getAttribute('src') === src) return;
    img.setAttribute('src', src);
    img.removeAttribute('srcset');
  }
  function setLinks(c, url) {
    if (!url) return;
    var a = c.querySelectorAll('[data-bc-link]');
    for (var i = 0; i < a.length; i++) a[i].setAttribute('href', url);
  }
  function preload(c) {
    if (c.__pre) return;
    c.__pre = true;
    var sws = c.querySelectorAll('[data-bc-sw]');
    for (var i = 0; i < sws.length; i++) {
      var src = sws[i].getAttribute('data-img');
      if (src) { var im = new Image(); im.decoding = 'async'; im.src = src; }
    }
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-bc-sort]')) {
      var f = e.target.closest('[data-bc-sortform]');
      if (f) f.submit();
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var sw = e.target.closest('[data-bc-sw]');
    if (!sw) return;
    e.preventDefault();
    var c = card(sw);
    if (!c) return;
    var all = c.querySelectorAll('[data-bc-sw]');
    for (var i = 0; i < all.length; i++) all[i].classList.toggle('is-on', all[i] === sw);
    c.__pick = { img: sw.getAttribute('data-img'), url: sw.getAttribute('data-url') };
    c.classList.add('is-picked');
    setImg(c, c.__pick.img);
    setLinks(c, c.__pick.url);
  });

  document.addEventListener('pointerover', function (e) {
    if (!e.target.closest) return;
    var c0 = card(e.target);
    if (c0) preload(c0);
    var sw = e.target.closest('[data-bc-sw]');
    if (!sw) return;
    var c = card(sw);
    if (!c) return;
    var img = c.querySelector('[data-bc-img]');
    if (img && !c.__base) c.__base = img.getAttribute('src');
    setImg(c, sw.getAttribute('data-img'));
  });

  document.addEventListener('pointerout', function (e) {
    if (!e.target.closest) return;
    var c = e.target.closest('[data-bc-card]');
    if (!c || c.contains(e.relatedTarget)) return;
    var back = (c.__pick && c.__pick.img) || c.__base;
    if (back) setImg(c, back);
  });
})();
